import { getItemBoxInterpolation } from 'app/core/markers/bounds';
import { hitTestArrowMarker, hitTestEllipticalFrame, hitTestHighlightMarker, hitTestImage, hitTestLineMarker, hitTestPathMarker, hitTestPin, hitTestPolylineMarker, hitTestRectFrame, hitTestSolidRect, hitTestText, hitTestZoomMarker, } from 'app/core/markers/hitTest';
export const hitTestMarker = (marker, point) => {
    if (!marker) {
        return false;
    }
    const bounds = getItemBoxInterpolation(marker);
    if (!bounds) {
        return false;
    }
    // check if in extended bounds
    if (!bounds.some(bbox => bbox
        .inflate(0.05 * bbox.width, 0.05 * bbox.height)
        .containsPoint(point))) {
        return false;
    }
    // run a detailed hittest
    switch (marker.alias) {
        case 'Arrow':
            return hitTestArrowMarker(marker, point);
        case 'Line':
            return hitTestLineMarker(marker, point);
        case 'Polyline':
            return hitTestPolylineMarker(marker, point);
        case 'Ellipse':
            return hitTestEllipticalFrame(marker, point);
        case 'Rect':
            return hitTestRectFrame(marker, point);
        case 'Highlight':
            return hitTestHighlightMarker(marker, point);
        case 'Path':
            return hitTestPathMarker(marker, point);
        case 'Blur':
            return hitTestSolidRect(marker, point);
        case 'Zoom':
            return hitTestZoomMarker(marker, point);
        case 'Spot':
            return hitTestSolidRect(marker, point);
        case 'Pin':
            return hitTestPin(marker, point);
        case 'Text':
            return hitTestText(marker, point);
        case 'Image':
            return hitTestImage(marker, point);
        default:
            return false;
    }
};
